// open n close mobile nav
$('.mobile-navigation__parent').click(function() {
  $('.mobile-navigation__child').slideUp('normal');
  if ($(this).next().is(':hidden') == true) {
    $(this).next().slideDown('normal');
  }
});
$('.mobile-navigation__child').hide();


// WEBPACK FOOTER //
// ./assets/js/features/mobileNavigation.js